import axios from 'axios'

export async function fetchCrmPipeline(params = {}) {
  const res = await axios.get('crm/pipeline', { params })
  return res.data
}

export async function fetchCrmTasks(params = {}) {
  const res = await axios.get('crm/tasks', { params })
  return res.data
}

export async function createCrmOpportunity(data) {
  const res = await axios.post('crm/opportunities', data)
  return res.data
}

export async function getCrmOpportunity(id) {
  const res = await axios.get(`crm/opportunities/${id}`)
  return res.data
}

export async function updateCrmOpportunity(id, data) {
  const res = await axios.patch(`crm/opportunities/${id}`, data)
  return res.data
}

export async function setCrmOpportunityStage(id, data) {
  const res = await axios.post(`crm/opportunities/${id}/stage`, data)
  return res.data
}

export async function addCrmActivity(opportunityId, data) {
  const res = await axios.post(`crm/opportunities/${opportunityId}/activities`, data)
  return res.data
}

export async function completeCrmActivity(activityId) {
  const res = await axios.post(`crm/activities/${activityId}/complete`)
  return res.data
}
